import React from "react";
import { useTranslation } from "react-i18next";
const FaqContact = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="bg-white w-100 p-4">
        <h5 className="fw-light text-uppercase">{t("ContactUsTitle")}</h5>
        <p className="fs-11 fw-light mt-3">{t("ContactUsDesc")}</p>
        <div className="row">
          <div className="col-lg-5 col-md-6 col-sm-8 col-12">
            <a
              href="/contact"
              className="btn bgcolorfooterbottom text-uppercase fs-14  px-4 pe-4 p-3 w-100 mt-2"
            >
              {t("ContactUsTitle")}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FaqContact;
